import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

const Modal = props => (props.showModal === true ? (
  <div className={`${styles[props.namespace]} ${styles.nurtureModalContainer}`} data-test="nurture-modal">
    <div
      className={`${styles.nurtureModal} ${styles.nurtureModalCentered} ${props.backgroundColor}`}
      style={{ width: `${props.width}` }}
    >
      {props.children}
    </div>
    <div className={styles.nurtureModalBackdrop} />
  </div>
) : null);

export default Modal;

Modal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  namespace: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
};

Modal.defaultProps = {
  backgroundColor: null,
};
